export const getUniqueObjectsFromArrayByKey = <T>(
  key: string,
  array: Array<T>
): Array<T> =>
  ([
    ...new Map(array.map(item => [item[key], item])).values(),
  ] as unknown) as Array<T>;
